import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import RestaurantDetail from './pages/RestaurantDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import MyReservations from './pages/MyReservations';
import MyTickets from './pages/MyTickets';
import MyProfile from './pages/MyProfile';
import Membership from './pages/Membership';
import MembershipPayments from './pages/MembershipPayments';
import VerifyMembership from './pages/VerifyMembership';
import MembershipPaymentResult from './pages/MembershipPaymentResult';
import ForgotPassword from './pages/ForgotPassword';
import VerifyResetOtp from './pages/VerifyResetOtp';
import ResetPassword from './pages/ResetPassword';
import RateReservation from './pages/RateReservation';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';
import GuestPayment from './pages/GuestPayment';
import GuestPaymentSuccess from './pages/GuestPaymentSuccess';
import ReservationWidget from './pages/ReservationWidget';
import ExperiencePage from './pages/ExperiencePage';
import ProgramPage from './pages/ProgramPage';
import MembershipWidget from './pages/MembershipWidget';
import EventTicketPayment from './pages/EventTicketPayment';
import GuestPortal from './pages/Portal/GuestPortal';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/restaurant/:id" element={<RestaurantDetail />} />
        <Route path="/widget" element={<ReservationWidget />} />
        <Route path="/experience/:id" element={<ExperiencePage />} />
        <Route path="/program/:restaurantId" element={<ProgramPage />} />
        <Route path="/membership-widget" element={<MembershipWidget />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/my-reservations" element={<MyReservations />} />
        <Route path="/my-tickets" element={<MyTickets />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/membership/payments" element={<MembershipPayments />} />
        <Route path="/membership/payment-success" element={<MembershipPaymentResult />} />
        <Route path="/membership/payment-refunded" element={<MembershipPaymentResult />} />
        <Route path="/membership/payment-error" element={<MembershipPaymentResult />} />
        <Route path="/verify-membership/:id" element={<VerifyMembership />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/rate/:reservationId" element={<RateReservation />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/pay/:token" element={<GuestPayment />} />
        <Route path="/guest-payment-success" element={<GuestPaymentSuccess />} />
        <Route path="/event-payment/:token" element={<EventTicketPayment />} />
        <Route path="/portal/r/:slug" element={<GuestPortal />} />
        <Route
          path="/portal"
          element={
            <div style={{ padding: 40, fontFamily: "Arial, sans-serif", textAlign: "center", maxWidth: 560, margin: "60px auto" }}>
              <h2 style={{ color: "#4A009F" }}>Open the link your restaurant sent you</h2>
              <p style={{ color: "#555", marginTop: 12 }}>
                The guest portal is now per-restaurant. Please use the link from your confirmation email, or contact the venue.
              </p>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
